exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "/* For dropdown elements to display a redish background on hover instead of the default greyish which blends with the page background */\r\n.dropdown-menu.show > .dropdown-item:hover {\r\n  background-color: #f9eeee;\r\n}\r\n\r\n/* for google autocomplete in modals https://github.com/twbs/bootstrap/issues/4160 */\r\n.pac-container {\r\n  z-index: 1051 !important;\r\n}\r\n\r\n/* For vue-multiselect, so that when the dropdown is readonly, the caret is hidden */\r\n.pix-select__input--readonly .multiselect__select {\r\n  display: none;\r\n}", ""]);

// exports
